import http from "@/services/http";

/**
 * Lista os sintomas já registrados de um paciente (tabela patient_symptoms).
 *
 * @param {number|string} patientId
 * @returns {Promise<object[]>} lista de patient_symptoms (`{ id, symptom, catalog, ... }`)
 */
export async function getSymptomsByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-symptoms/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Lista o catálogo de sintomas (referência, com SNOMED).
 *
 * @returns {Promise<Array<{id:number, name:string, snomed_code:string|null}>>}
 */
export async function getSymptomCatalog() {
  const { data } = await http.get("/api/symptom-catalog");
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Adiciona um ou vários sintomas de uma vez ao paciente.
 *
 * @param {number|string} patientId
 * @param {object[]} symptoms lista `[{ symptom, symptom_catalog_id?, reported_at?, notes? }]`
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export function createSymptoms(patientId, symptoms) {
  return http.post("/api/patient-symptoms/create", {
    patient_id: patientId,
    symptoms: symptoms.map((s) => ({
      symptom: s.symptom,
      symptom_catalog_id: s.symptom_catalog_id || null,
      reported_at: s.reported_at || null,
      notes: s.notes || null,
    })),
  });
}

/**
 * Remove um sintoma do paciente (soft delete).
 *
 * @param {number} id
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export function deleteSymptom(id) {
  return http.delete(`/api/patient-symptoms/delete/${id}`);
}
